type ParseAmountToSmallestUnitParams = {
  amount: string;
  decimals: number;
};

/**
 * Converts a human-readable decimal amount string to the smallest unit
 * representation as a bigint, using string-based arithmetic to avoid
 * floating-point precision loss.
 *
 * @example
 * parseAmountToSmallestUnit({ amount: '1.5', decimals: 9 })   // 1500000000n  (1.5 SOL in lamports)
 * parseAmountToSmallestUnit({ amount: '1.5', decimals: 8 })   // 150000000n   (1.5 BTC in satoshis)
 * parseAmountToSmallestUnit({ amount: '10.5', decimals: 6 })  // 10500000n    (10.5 USDC)
 * parseAmountToSmallestUnit({ amount: '0.1', decimals: 9 })   // 100000000n   (no float error)
 *
 * @param params.amount - The amount as a decimal string (e.g. "1.5").
 * @param params.decimals - The number of decimal places for the token.
 * @returns The amount in smallest units as a bigint.
 */
export const parseAmountToSmallestUnit = ({
  amount,
  decimals,
}: ParseAmountToSmallestUnitParams): bigint => {
  const [whole = '0', fraction = ''] = amount.split('.');
  const paddedFraction = fraction.padEnd(decimals, '0').slice(0, decimals);
  return BigInt(whole + paddedFraction);
};
